<div class="status-bar-colored-top"></div>
<div class="status-bar-colored-bottom"></div>
<div class="padding-safe-top full-size-safe-scrollable">
<div *ngIf="hymn" style="height: 100%; overflow: hidden; position: relative;">
  <mat-toolbar color="primary" class="sticky-toolbar-router">
    @if (!sidenavService.hymnListOpen) {
      <div class="padding-safe-left"></div>
    }

    <button (click)="toggleListSidenav()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>

    <span [matMenuTriggerFor]="hymnInfoMenu" class="title-ellipsis" *ngIf="hymn">
      {{translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title}}
    </span>

    <mat-menu #hymnInfoMenu="matMenu">
      <button mat-menu-item>
        <span>{{translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title}}</span>
      </button>
    </mat-menu>

    <span class="toolbar-fill-remaining-space"></span>

    <button *ngIf="settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" (click)="settingService.removeHymnFromFavoritesAndToLearn(hymn);" mat-icon-button>
      <mat-icon *ngIf="settingService.isFavorite(hymn.hymnNumber)">favorite</mat-icon>
      <mat-icon *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">bookmark</mat-icon>
    </button>

    <button *ngIf="!settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" [matMenuTriggerFor]="favoriteMenu" mat-icon-button>
      <mat-icon>favorite_border</mat-icon>
    </button>

    <mat-menu #favoriteMenu="matMenu">
      <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
        <mat-icon>favorite_border</mat-icon>
        <span>{{translation.add_to_favorites}}</span>
      </button>
      <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
        <mat-icon>bookmark_border</mat-icon>
        <span>{{translation.add_to_hymns_to_learn}}</span>
      </button>
    </mat-menu>

    <button mat-icon-button (click)="hymnSelectionService.dialpad()">
      <mat-icon>dialpad</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="shuffleMenu">
      <mat-icon>shuffle</mat-icon>
    </button>

    <mat-menu #shuffleMenu="matMenu">
      <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
        <mat-icon>shuffle</mat-icon>
        <span>{{translation.random_favorite}}</span>
      </button>
      <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
        <mat-icon>shuffle</mat-icon>
        <span>{{translation.random_hymn}}</span>
      </button>
    </mat-menu>

    @if(!layoutService.isNarrow()) {
      <button mat-icon-button [matMenuTriggerFor]="viewModeMenu">
        <mat-icon>menu_book</mat-icon>
      </button>

      <mat-menu #viewModeMenu="matMenu">
        <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
          <mat-icon>menu_book</mat-icon>
          <span>{{translation.read_mode}}</span>
        </button>
        <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_chords, hymn.hymnNumber]" mat-menu-item>
          <mat-icon svgIcon="guitar"></mat-icon>
          <span>{{translation.chord_mode}}</span>
        </button>
        <button (click)="settingService.setPresentationViewMode()" [routerLink]="['/'+translation.path_present, hymn.hymnNumber]" mat-menu-item>
          <mat-icon>tv</mat-icon>
          <span>{{translation.presentation_mode}}</span>
        </button>
      </mat-menu>

      <span class="toolbar-separator"></span>

      <button mat-icon-button [matMenuTriggerFor]="pdfThemeMenu" aria-label="PDF theme">
        <mat-icon>brightness_6</mat-icon>
      </button>
      <mat-menu #pdfThemeMenu="matMenu">
        <button mat-menu-item (click)="setPdfThemeMode('white')">
          <mat-icon>{{ pdfThemeMode === 'white' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
          <span>White</span>
        </button>
        <button mat-menu-item (click)="setPdfThemeMode('day')">
          <mat-icon>{{ pdfThemeMode === 'day' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
          <span>Day</span>
        </button>
        <button mat-menu-item (click)="setPdfThemeMode('night')">
          <mat-icon>{{ pdfThemeMode === 'night' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
          <span>Night</span>
        </button>
        <button mat-menu-item (click)="setPdfThemeMode('black')">
          <mat-icon>{{ pdfThemeMode === 'black' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
          <span>Black</span>
        </button>
      </mat-menu>

      <button mat-icon-button (click)="zoomOut()" aria-label="Zoom out">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button mat-icon-button (click)="resetZoom()" aria-label="Reset zoom">
        <mat-icon>find_replace</mat-icon>
      </button>
      <button mat-icon-button (click)="zoomIn()" aria-label="Zoom in">
        <mat-icon>zoom_in</mat-icon>
      </button>

    }

    <button mat-icon-button [matMenuTriggerFor]="optionsMenu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #optionsMenu="matMenu">

      @if(layoutService.isNarrow()) {
        <button mat-menu-item [matMenuTriggerFor]="viewModeMenu">
          <mat-icon>menu_book</mat-icon>
          <span>View Mode</span>
        </button>

        <mat-menu #viewModeMenu="matMenu">
          <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
            <mat-icon>menu_book</mat-icon>
            <span>{{translation.read_mode}}</span>
          </button>
          <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_chords, hymn.hymnNumber]" mat-menu-item>
            <mat-icon svgIcon="guitar"></mat-icon>
            <span>{{translation.chord_mode}}</span>
          </button>
          <button (click)="settingService.setPresentationViewMode()" [routerLink]="['/'+translation.path_present, hymn.hymnNumber]" mat-menu-item>
            <mat-icon>tv</mat-icon>
            <span>{{translation.presentation_mode}}</span>
          </button>
        </mat-menu>

        <button mat-menu-item [matMenuTriggerFor]="pdfThemeMenu" aria-label="PDF theme">
          <mat-icon>brightness_6</mat-icon>
          <span>Day/Night Mode</span>
        </button>
        <mat-menu #pdfThemeMenu="matMenu">
          <button mat-menu-item (click)="setPdfThemeMode('white')">
            <mat-icon>{{ pdfThemeMode === 'white' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>White</span>
          </button>
          <button mat-menu-item (click)="setPdfThemeMode('day')">
            <mat-icon>{{ pdfThemeMode === 'day' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Day</span>
          </button>
          <button mat-menu-item (click)="setPdfThemeMode('night')">
            <mat-icon>{{ pdfThemeMode === 'night' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Night</span>
          </button>
          <button mat-menu-item (click)="setPdfThemeMode('black')">
            <mat-icon>{{ pdfThemeMode === 'black' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Black</span>
          </button>
        </mat-menu>

        <button mat-menu-item (click)="zoomIn()" aria-label="Zoom in">
          <mat-icon>zoom_in</mat-icon>
          <span>Zoom In</span>
        </button>
        <button mat-menu-item (click)="resetZoom()" aria-label="Reset zoom">
          <mat-icon>find_replace</mat-icon>
          <span>Reset Zoom</span>
        </button>
        <button mat-menu-item (click)="zoomOut()" aria-label="Zoom out">
          <mat-icon>zoom_out</mat-icon>
          <span>Zoom Out</span>
        </button>

        <!-- Previous/Next clef navigation in single-view menu -->
        <button mat-menu-item (click)="jumpGlyph(-1)" aria-label="Previous clef">
          <mat-icon>keyboard_arrow_up</mat-icon>
          <span>Previous clef</span>
        </button>
        <button mat-menu-item (click)="jumpGlyph(1)" aria-label="Next clef">
          <mat-icon>keyboard_arrow_down</mat-icon>
          <span>Next clef</span>
        </button>
      }

      <button *ngIf="layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareHymn(this.hymn)">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_hymn + " " + hymn.hymnNumber}}</span>
      </button>

      <button mat-menu-item *ngIf="layoutService.fullscreenSupported()" (click)="layoutService.toggleFullScreen()">
        <mat-icon *ngIf="!layoutService.fullscreen">fullscreen</mat-icon>
        <mat-icon *ngIf="layoutService.fullscreen">fullscreen_exit</mat-icon>
        <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
      </button>


      <button *ngIf="!layoutService.singleView" mat-menu-item (click)="modalService.openDialog('shortcuts')">
        <mat-icon>keyboard_command_key</mat-icon>
        <span>{{translation.shortcuts}}</span>
      </button>

      <button (click)="toggleSettingSidenav()" mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>{{translation.settings}}</span>
      </button>

      <button *ngIf="!layoutService.isNarrow() && layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareApp();">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_app}}</span>
      </button>
    </mat-menu>

    @if (!settingService.settingsOpened) {
      <div class="padding-safe-right"></div>
    }
  </mat-toolbar>

<div class="pdf-viewport">
  <div class="pdf-container" #pdfContainer [ngClass]="pdfThemeClass()" doubletap (doubletap)="onDoubleTap()" *ngIf="!pdfError; else pdfErrorTpl">
      <pdf-viewer
        [src]="pdfSrc"
        [render-text]="true"
        [show-all]="true"
        [zoom]="zoom"
        [original-size]="false"
        [autoresize]="true"
        style="display:block; width:100%; height:100%"
        (after-load-complete)="onPdfLoaded($event)"
        (error)="onPdfError($event)">
      </pdf-viewer>
  </div>
  <!-- Bottom-left clef navigation controls, anchored to the sheet music viewport -->
  <div class="clef-nav" *ngIf="!pdfError && clefUiEnabled">
    <button mat-fab color="primary" (click)="jumpGlyph(1)" aria-label="Next clef">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
</div>
  <ng-template #pdfErrorTpl>
    <div class="pdf-error">
      {{ 'PDF not available for hymn ' + hymn.hymnNumber }}
    </div>
  </ng-template>


  <app-music-control [autoscrollVisible]="false" class="music-control-menu"></app-music-control>
</div>
</div>
